module.exports = Promise.resolve(module.bundle.root("l6tqQ"))